/**
 * Professional Create Page
 * Page for creating a new healthcare professional
 */
import React, { useState } from 'react';
import { PageShell } from '../../components';
import ProfessionalForm from './components/ProfessionalForm';
import { professionalService } from '../../services/professionalService';
import { CreateProfessionalRequest, UpdateProfessionalRequest } from '../../types/professional';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const ProfessionalCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: CreateProfessionalRequest | UpdateProfessionalRequest) => {
    setIsSubmitting(true);
    try {
      const criado = await professionalService.createProfessional(data as CreateProfessionalRequest);
      enqueueSnackbar('Profissional cadastrado com sucesso!', { variant: 'success' });
      /*
        Termina na FICHA do recém-criado: é ali que ficam as ARTs, e quem
        acabou de cadastrar um profissional as encontra sem precisar de aviso.
        O `POST /professionals` devolve o registro criado com `id`.
      */
      navigate(`/professionals/${criado.id}`);
    } catch (error: unknown) {
      const apiError = error as { response?: { data?: { message?: string; error?: string } }; message?: string };
      const errorMessage = (apiError.response?.data?.message || apiError.response?.data?.error || apiError.message) ?? 'Erro ao cadastrar profissional';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/professionals');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/home' },
        { label: 'Profissionais', path: '/professionals' },
        { label: 'Cadastrar' },
      ]}
      title="Cadastrar Novo Profissional"
    >
      <ProfessionalForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isSubmitting={isSubmitting}
      />
    </PageShell>
  );
};

export default ProfessionalCreatePage;
